// Malay (Bahasa Malaysia, "anda") copy for /preview-first-uploads, translated from copy.en.ts. Same shape
// (checked by copy.test.ts). The second pass is always "fail asal" (never "kualiti penuh"). The uploader's own
// labels are in English, so they're quoted as it shows them.
import type { PreviewFirstCopy } from "./copy.en";

const ms: PreviewFirstCopy = {
  seo: {
    title: "Muat naik pratonton dahulu, pada semua pelan | Photohawk",
    description:
      "Baharu dalam pemuat naik web Photohawk, pada semua pelan: pratonton kecil setiap foto dimuat naik dahulu, supaya galeri anda boleh dalam talian, menjual dan dikongsi dalam beberapa minit sementara fail asal menyusul di latar belakang.",
  },
  hero: {
    badge: "Baharu",
    eyebrow: "Dalam pemuat naik web · Semua pelan",
    title: "Galeri anda dalam talian dalam beberapa minit,",
    titleHighlight: "bukan berjam-jam",
    subtitle:
      "Pemuat naik web kini menghantar pratonton kecil setiap foto dahulu. Galeri anda boleh dalam talian dengan pratonton itu, jadi pembeli boleh mencari, membeli dan berkongsi foto mereka sementara fail asal terus dimuat naik di latar belakang.",
    ctaPrimary: "Buka pemuat naik",
    ctaSecondary: "Lihat cara ia berfungsi",
    uploaderLink: "Lihat semua yang baharu dalam pemuat naik web",
  },
  steps: {
    heading: "Cara ia berfungsi",
    subtitle: "Pratonton dahulu ada dalam pemuat naik web, pada semua pelan. Apabila anda menambah foto, ia menunjukkan berapa lama setiap cara mengambil masa, dan anda memilih “Previews first, originals later”.",
    stepLabel: "Langkah {n}",
    items: [
      {
        id: "add",
        title: "Tambah foto anda",
        body: "Letakkan foto atau seluruh folder, seperti biasa. Pelayar anda membuat pratonton kecil bagi setiap foto, terus pada komputer anda.",
      },
      {
        id: "previews",
        title: "Pratonton dimuat naik dahulu",
        body: "Pratonton bersaiz kecil, jadi ia dimuat naik dengan cepat, walaupun dengan sambungan perlahan di lokasi acara.",
      },
      {
        id: "live",
        title: "Galeri anda dalam talian",
        body: "Terbitkan sebaik sahaja pratonton selesai dimuat naik, atau tandakan “Publish the gallery as soon as the previews are up” dan ia berlaku dengan sendirinya. Pembeli boleh melayari, mencari, membeli dan berkongsi serta-merta.",
      },
      {
        id: "full",
        title: "Fail asal menyusul",
        body: "Fail asal terus dimuat naik di latar belakang, ke dalam foto yang sama. Muat turun dan cetakan sentiasa menggunakan fail asal.",
      },
    ],
    timeline: {
      label: "Contoh muat naik, dari mula hingga akhir",
      previews: "Pratonton",
      previewsTime: "beberapa minit",
      live: "Galeri dalam talian",
      full: "Fail asal",
      fullTime: "di latar belakang",
    },
  },
  buyers: {
    heading: "Apa yang dilihat oleh pembeli",
    subtitle: "Tiada apa-apa yang baharu untuk dipelajari. Pembeli mendapat galeri yang mereka kenali, cuma lebih awal.",
    items: [
      {
        id: "protected",
        title: "Bertera air dan dilindungi, seperti biasa",
        body: "Pembeli melayari pratonton bertera air yang sama seperti biasa, dan perlindungan pratonton berfungsi sama jika galeri anda menggunakannya.",
      },
      {
        id: "search",
        title: "Mereka boleh mencari diri sendiri serta-merta",
        body: "Carian swafoto dan nombor bib berfungsi pada pratonton, jadi orang ramai boleh mencari foto mereka sebaik sahaja galeri dalam talian.",
      },
      {
        id: "delivery",
        title: "Fail asal, dihantar secara automatik",
        body: "Pembelian atau muat turun percuma tidak pernah dihantar sebagai pratonton. Jika seseorang membeli atau memuat turun foto sebelum fail asalnya tiba, fail asal itu didahulukan dalam baris gilir, dan mereka akan menerimanya sebaik sahaja ia sedia.",
      },
    ],
  },
  strip: {
    heading: "Pantau semasa anda memuat naik",
    body: "Semasa pratonton dan fail asal dimuat naik, jalur di bahagian atas pemuat naik menunjukkan kedudukan galeri anda: sama ada ia sudah dalam talian, berapa banyak fail asal yang tinggal, dan bila foto yang dibeli telah didahulukan. Sebaik sahaja galeri dalam talian, ia juga menunjukkan berapa ramai orang yang melawatinya dalam 30 minit terakhir, dan pemilik serta pentadbir ruang kerja dapat melihat pesanan baharu sejak muat naik bermula.",
    exampleLabel: "Contoh",
    live: "Dalam talian dengan pratonton",
    orders: "3 pesanan sejak anda bermula",
    visitors: "42 pelawat dalam 30 minit terakhir",
    left: "1,250 fail asal lagi",
    jumped: "Fail asal 2 foto yang dipesan telah didahulukan",
  },
  faq: {
    heading: "Soalan",
    items: [
      {
        q: "Perlukah saya biarkan pemuat naik terbuka?",
        a: "Lebih baik begitu, sehingga fail asal selesai; jalur itu menunjukkan berapa banyak yang tinggal. Jika anda menutupnya lebih awal, tiada apa-apa yang hilang. Galeri anda kekal dalam talian dengan pratonton, dan apabila anda membuka galeri itu dalam pemuat naik pada kali seterusnya, ia akan memberitahu berapa banyak foto yang masih menunggu. Tambah folder yang sama sekali lagi (walaupun kemudian, dari rumah) dan hanya fail asal yang tertinggal akan dihantar.",
      },
      {
        q: "Bagaimana jika seseorang membeli foto sebelum fail asalnya tiba?",
        a: "Mereka masih boleh membelinya. Selagi pemuat naik berjalan, fail asal foto itu didahulukan dalam baris gilir. E-mel pesanan menunggu fail itu dan dihantar dalam beberapa minit selepas ia tiba, jadi pembeli tidak akan menerima pratonton secara tidak sengaja. Jika pemuat naik telah ditutup, pesanan menunggu sehingga anda menambah folder itu sekali lagi. Pemuat naik memberitahu anda foto mana yang sedang ditunggu oleh pembeli, dan foto itu dihantar dahulu.",
      },
      {
        q: "Adakah ia berfungsi untuk galeri muat turun percuma?",
        a: "Ya. Orang ramai boleh melihat, mencari dan memuat turun sebaik sahaja pratonton selesai dimuat naik, dan muat turun tidak pernah berupa pratonton. Jika seseorang memuat turun foto sebelum fail asalnya tiba, fail asal itu didahulukan dalam baris gilir: muat turun mereka menunjukkan bahawa fail asal sedang dimuat naik dan menjadi muat turun yang berfungsi sebaik sahaja fail itu tiba, dan muat turun melalui e-mel juga dihantar pada masa itu. Setiap muat turun dikira sekali sahaja.",
      },
      {
        q: "Adakah carian swafoto dan nombor bib berfungsi pada pratonton?",
        a: "Ya. Wajah dan nombor bib dikesan pada pratonton, jadi carian berfungsi sebaik sahaja pratonton dimuat naik. Semasa pemuat naik dibuka, ia juga menghantar gambar dekat yang lebih tajam daripada fail asal anda untuk membantu carian.",
      },
      {
        q: "Pelan manakah yang menyertakannya?",
        a: "Semua pelan, termasuk Lite. Jika ruang kerja anda pernah menggunakan pratonton dahulu, foto tersebut tetap selesai seperti biasa: tambah folder yang sama sekali lagi dan fail asalnya akan dihantar, dan pesanan serta muat turunnya tetap sampai.",
      },
      {
        q: "Adakah ia dikenakan bayaran tambahan?",
        a: "Tidak. Ia termasuk dalam semua pelan, dan setiap foto dikira sekali: pratonton dan fail asalnya ialah foto yang sama. Satu-satunya perbezaan ialah sambungan anda menghantar sedikit lebih banyak data secara keseluruhan (kira-kira 5% lebih).",
      },
      {
        q: "Adakah ia berfungsi dengan FTP dan Photohawk Studio?",
        a: "Tidak buat masa ini. Pratonton dahulu ialah sebahagian daripada pemuat naik web. Foto yang dihantar melalui FTP atau dari Photohawk Studio dimuat naik sebagai fail asal sekali gus, seperti sebelum ini.",
      },
      {
        q: "Adakah ia dihidupkan secara lalai?",
        a: "Tidak. Setiap kali anda menambah foto, pemuat naik web menunjukkan berapa lama ia mengambil masa dengan dan tanpa pratonton dahulu, dan menghantar fail asal terus dipilih. Pilih “Previews first, originals later” apabila anda mahu galeri dalam talian lebih awal; pemuat naik web mengingati pilihan anda untuk kali seterusnya. Dengan resolusi muat naik yang lebih kecil (“Large” atau “Web”), hanya fail yang telah diubah saiz dimuat naik, jadi pratonton dahulu tidak digunakan.",
      },
    ],
  },
  cta: {
    heading: "Cuba pada muat naik anda yang seterusnya",
    body: "Pratonton dahulu ada dalam pemuat naik web, pada semua pelan. Tambah foto anda, pilih pratonton dahulu, dan galeri anda boleh dalam talian dalam beberapa minit.",
    button: "Buka pemuat naik",
  },
};

export default ms;
